import { useEffect, useState } from "react";
import { Button, IconButton } from "@mui/material";
import { Edit, LibraryAdd } from "@mui/icons-material";
import { BreadcrumbsWidget, DataTableWrap } from "components";
import DeleteIcon from "@mui/icons-material/Delete";
import SetArticleModal from "./SetArticleModal";
import {
  useDeleteArticleMutation,
  useRemoveArticleCategoryMutation,
} from "redux/api/slices/server";
import { useMakaleAramaMutation } from "api/search";
import { useResponseAll, useResponseErrorOnly } from "hooks";
import SearchBar from "./SearchBar";

const ArticlesPage = () => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(false);
  const [deleteArticle, deleteReq] = useDeleteArticleMutation();
  const [removeArticleCategory, reqData] = useRemoveArticleCategoryMutation();
  const [MakaleArama, search] = useMakaleAramaMutation();

  const handleModal = (id) => {
    const selectedItem = search.data.find((item) => item.id === id);
    setSelected(selectedItem);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const columns = [
    {
      name: "Başlıık",
      selector: (row) => row.title,
      sortable: true,
    },
    {
      name: "Makalenin Kategorisi",
      selector: (row) => row.category,
      sortable: true,
    },
    {
      name: "Ürünlere Ekle",
      cell: (row) => {
        return (
          <Button
            onClick={() => handleModal(row.id)}
            variant="contained"
            size="small"
            color="primary"
            endIcon={<LibraryAdd />}
          >
            Ürünlere Ekle
          </Button>
        );
      },
    },
    {
      name: "Ürünlerden Kaldır",
      width: "250px",
      cell: (row) => {
        return (
          <Button
            onClick={() =>
              removeArticleCategory({
                articleId: row.id,
              })
            }
            variant="contained"
            size="small"
            color="error"
            endIcon={<DeleteIcon />}
          >
            Tüm Ürünlerden Kaldır
          </Button>
        );
      },
    },
    {
      right: true,
      width: "10px",
      cell: (row) => {
        return (
          <IconButton
            aria-label="detaitl"
            size="small"
            href={`/detail-article/${row.id}`}
          >
            <Edit fontSize="inherit" />
          </IconButton>
        );
      },
    },
  ];

  useResponseErrorOnly(search);
  useResponseAll(deleteReq);
  useResponseAll(reqData);

  useEffect(() => {
    MakaleArama({});
  }, [MakaleArama]);

  return (
    <div className="w-full my-6">
      <div className="w-full px-10">
        <BreadcrumbsWidget activeItem="Makaleler" />
        <SearchBar Arama={MakaleArama} data={search} />
        <div className="w-full h-auto flex flex-col p-5 gap-4 border shadow bg-white">
          <div className="w-full h-auto block">
            <DataTableWrap
              title="Makaleler"
              columns={columns}
              initialData={search.data}
              externalFunction={deleteArticle}
            />
            <SetArticleModal
              id="ringtone-menu"
              keepMounted
              open={open}
              selectedItem={selected}
              onClose={handleClose}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticlesPage;
